import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-new_plateform",
  "use": "icon-new_plateform-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-new_plateform\">\r\n  <path d=\"M832 403.498667a21.333333 21.333333 0 0 0 21.333333-21.333334V276.736A106.24 106.24 0 0 0 747.136 170.666667H276.864A106.24 106.24 0 0 0 170.666667 276.736v342.528A106.24 106.24 0 0 0 276.864 725.333333h470.272A106.24 106.24 0 0 0 853.333333 619.264V512a21.333333 21.333333 0 0 0-42.666666 0v107.264A63.573333 63.573333 0 0 1 747.136 682.666667H276.864A63.573333 63.573333 0 0 1 213.333333 619.264V276.736A63.573333 63.573333 0 0 1 276.864 213.333333h470.272A63.573333 63.573333 0 0 1 810.666667 276.736v105.429333a21.333333 21.333333 0 0 0 21.333333 21.333334M792.874667 810.666667H232.874667a21.333333 21.333333 0 0 0 0 42.666666h560a21.333333 21.333333 0 0 0 0-42.666666\" p-id=\"6948\" fill=\"#ffffff\">\r\n  </path>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/new_plateform.svg
// module id = 5Z8O
// module chunks = 1